export default "__VITE_ASSET__zUusRKQS__"